import angular from 'angular';
import template from './patient-modal-continue-with-blocked-video.html';
import bowser from 'bowser';
class ModalPatientModalContinueWithBlockedVideoController {
    constructor(Browser) {
        this.Browser = Browser;
    }
    $onInit() {
        this.articleUrl = this.Browser.getHelpArticleUrl();
        this.isDesktopChrome = bowser.chrome && !bowser.mobile && !bowser.tablet;
    }
}
const patientModalContinueWithBlockedVideo = {
    template,
    bindings: {
        patient: '<',
        room: '<',
        onCheckIn: '&',
        checkInPromise: '<',
    },
    controller: ModalPatientModalContinueWithBlockedVideoController,
};
export default angular
    .module('doxy.patient.modal.patientModalContinueWithBlockedVideo', [])
    .component('patientModalContinueWithBlockedVideo', patientModalContinueWithBlockedVideo).name;
